// External imports
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Chart from "react-apexcharts";
import { _HttpServices } from "../../../_services/_HttpServices";

const PieChart = (props, { dispatch, login }) => {
  const [pieChartData, setPieChartData] = useState([]);
  const [colorCodes, setColorCodes] = useState(props.colorCodes)

  // Local imports
  const apexPie = {
    series: [],
    chart: {
      width: 380,
      type: "pie",
      events: {},
      foreColor: '#000'
    },
    labels: props.barLabelsList,
    colors: props.barColorCodes,
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
            events: {},
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
    legend: {
      show: false,
    },
    noData: {
      text: 'No records to display'
    }
  };

  const [chartJsPieApex, setChartJsPieApex] = useState(apexPie);

  useEffect(() => {
    setPieChartData(props.taskData);
    makePieChart();
    setColorCodes(props.colorCodes)
  }, [props, pieChartData]);

  // Creating chart fn
  const makePieChart = () => {
    let taskNames = [];
    var StageCopyInProgress = 0;
    var StageCopyFailed = 0;
    var ReadyForProcess = 0;
    var InProcess = 0;
    var ProcessSuccess = 0;
    var ProcessFail = 0;
    var ReadyForstageQueue = 0;
    var QueuedForStaging = 0;
    var StageCopyCompleted = 0;
    var Duplicate = 0;
    var Acknowledged = 0;

    var ReadyForSendOutBoundFile = 0;
    var FileDelivered = 0;
    var BatchProcessFailed = 0;
    var TransferCopySuccess = 0;
    var TransferCopyFail = 0;

    if (pieChartData.length > 0) {
      pieChartData.map((item, i) => {
        // Pushing tasknames for to display in categories of chart
        taskNames.push(item.TaskName);

        // Pushing the relevant data count which is coming from API
        StageCopyInProgress = StageCopyInProgress + pieChartData[i].StageCopyInProgressCount;
        StageCopyFailed = StageCopyFailed + pieChartData[i].StageCopyFailedCount;
        ReadyForProcess = ReadyForProcess + pieChartData[i].ReadyForProcessCount;
        InProcess = InProcess + pieChartData[i].InProcessCount;
        ProcessSuccess = ProcessSuccess + pieChartData[i].ProcessSuccessCount;
        ProcessFail = ProcessFail + pieChartData[i].ProcessFailCount;
        ReadyForstageQueue = ReadyForstageQueue + pieChartData[i].ReadyForStageQueueCount;
        QueuedForStaging = QueuedForStaging + pieChartData[i].QueuedForStagingCount;
        Duplicate = Duplicate + pieChartData[i].DuplicateCount;
        Acknowledged = Acknowledged + pieChartData[i].AcknowledgedCount;
        StageCopyCompleted = StageCopyCompleted + pieChartData[i].StageCopyCompleted;
      });

      // Pushing the chart series data based on name
      let lSeries = [];
      lSeries.push(
        StageCopyInProgress,
        StageCopyFailed,
        ReadyForProcess,
        InProcess,
        ProcessSuccess,
        ProcessFail,
        ReadyForSendOutBoundFile,
        ReadyForstageQueue,
        QueuedForStaging,
        Duplicate,
        Acknowledged,
        StageCopyCompleted,
        FileDelivered,
        BatchProcessFailed,
        TransferCopySuccess,
        TransferCopyFail
      );
      if (lSeries.length > 0) {
        setChartJsPieApex({ ...chartJsPieApex, series: lSeries });
        chartJsPieApex.chart.events.dataPointSelection = pieChartClick2;
      }
    } else {
      setChartJsPieApex({ ...chartJsPieApex, series: [] });
    }
  };

  // Chart click fn
  const pieChartClick2 = (event, chartContext, config) => {
    let statusName = chartContext.w.config.labels[config.dataPointIndex];
    // alert(statusName)
    let statusId;
    if (statusName !== undefined && statusName === "Stage Copy Inprogress") {
      statusId = 1;
      props.pieChartClick(statusId);
    }
    if (statusName !== undefined && statusName === "Stage Copy Failed") {
      statusId = 2;
      props.pieChartClick(statusId);
    }
    if (statusName !== undefined && statusName === "Ready For Process") {
      statusId = 3;
      props.pieChartClick(statusId);
    }
    if (statusName !== undefined && statusName === "Inprocess") {
      statusId = 4;
      props.pieChartClick(statusId);
    }
    if (statusName !== undefined && statusName === "Process Success") {
      statusId = 5;
      props.pieChartClick(statusId);
    }
    if (statusName !== undefined && statusName === "Process Fail") {
      statusId = 6;
      props.pieChartClick(statusId);
    }
    if (statusName !== undefined && statusName === "Ready For Send Outbound File") {
      statusId = 7;
      props.pieChartClick(statusId);
    }
    if (statusName !== undefined && statusName === "Ready For Stage Queue") {
      statusId = 8;
      props.pieChartClick(statusId);
    }
    if (statusName !== undefined && statusName === "Queued For Staging") {
      statusId = 9;
      props.pieChartClick(statusId);
    }
    if (statusName !== undefined && statusName === "Duplicate") {
      statusId = 10;
      props.pieChartClick(statusId);
    }
    if (statusName !== undefined && statusName === "Acknowledged") {
      statusId = 11;
      props.pieChartClick(statusId);
    }
    if (statusName !== undefined && statusName === "Stage Copy Completed") {
      statusId = 12;
      props.pieChartClick(statusId);
    }
    if (statusName !== undefined && statusName === "File Delivered") {
      statusId = 13;
      props.pieChartClick(statusId);
    }
    if (statusName !== undefined && statusName === "Batch Process Failed") {
      statusId = 14;
      props.pieChartClick(statusId);
    }
    if (statusName !== undefined && statusName === "Transfer Copy Success") {
      statusId = 15;
      props.pieChartClick(statusId);
    }
    if (statusName !== undefined && statusName === "Transfer Copy Fail") {
      statusId = 16;
      props.pieChartClick(statusId);
    }
  };

  return (
    <section className="pie-chart pb-3">
      {props.taskData.length > 0 && colorCodes ?
        <Chart
          options={chartJsPieApex}
          series={chartJsPieApex.series}
          type="pie"
          height={340}
          width="100%"
        /> : <div className="no-data">No data found.</div>}
    </section>
  );
};

// Map Redux state to React component props
const mapStateToProps = (state) => ({
  loading: state.users.loading,
  login: state.users.login,
  users: state.users.users,
  hasErrors: state.users.hasErrors,
});

// Connect Redux to React
export default connect(mapStateToProps)(PieChart);
